<template>
  <div class="add-enum-row" >
    <!-- 枚举定义 -->
    <div class="section-title">{{ Lang.Title.modelEnumDef }}</div>
    <div class="line"></div>
    <comp-button
      type="info"
      v-if="!isView"
      icon="icon-add"
      @click="addDefinition">{{ Lang.btn.add }}</comp-button>
  </div>
  <el-table :data="enumTableData" border class="add-measure-point-table">
    <el-table-column prop="parameter">
      <template #header="{ column: col }">
        <div> {{  Lang.Title.standardPointParam }} <span class="required">*</span></div>
      </template>
      <template #default="{ $index }">
        <el-input
          type="number"
          maxlength="100"
          :disabled="isView"
          v-model="enumTableData[$index].parameter"
          :placeholder="isView ? '' : Lang.tips.plzInput + Lang.Title.standardPointParam"
        />
      </template>
    </el-table-column>
    <el-table-column
      v-for="item in languageOptions"
      :key="item.key"
      :prop="item.key"
    >
      <template #header="{ column: col }">
        <div> {{  Lang.label.name + '_' + item.name }} <span v-if="item.name === 'EN'" class="required">*</span></div>
      </template>
      <template #default="{ $index }">
        <el-input
          maxlength="100"
          :disabled="isView"
          v-model="enumTableData[$index][item.key]"
          :placeholder="isView ? '' :  Lang.tips.plzInput + Lang.Title.modelPoint"
        />
      </template>
    </el-table-column>
    <el-table-column :label="Lang.Title.modelAction" v-if="!isView">
      <template #default="{ $index }">
        <CompIconButton
          type="delete"
          color="#192434"
          size="20px"
          :authorize="true"
          :divider="false"
          @click="removeDefinition($index)"
        ></CompIconButton>
      </template>
    </el-table-column>
  </el-table>
</template>

<script setup>
import { reactive, toRefs } from 'vue';

const props = defineProps({
  enumTableData: {
    type: Array,
    required: true,
  },
  languageOptions: {
    type: Array,
    required: true,
  },
  isView: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:enumTableData']);

function addDefinition() {
  const newRow = props.languageOptions.reduce((acc, item) => {
    acc[item.key] = '';
    return acc;
  }, { parameter: '' });
  props.enumTableData.push(newRow);
  emit('update:enumTableData', props.enumTableData);
}

function removeDefinition(index) {
  props.enumTableData.splice(index, 1);
  emit('update:enumTableData', props.enumTableData);
}

</script>

<style scoped>
.add-row {
  margin-bottom: 10px;
}
</style>